const PopupContainer = () => (
    <div
        id="popup-container"
        style={{ position: 'relative', width: '100%', height: '100%' }}
    >

    </div>
);

export default PopupContainer;
